import type { ColumnType } from '@mondaydotcomorg/api-types';

type SUBITEM_FILTER_CONDITIONST = {
  [key in ColumnType]: { label: string; value: string }[];
};

const SUBITEM_FILTER_CONDITIONS: Partial<SUBITEM_FILTER_CONDITIONST> = {
  // [ColumnType.Status] Could use this after solving import issues

  status: [
    {
      label: 'is',
      value: 'is',
    },
    {
      label: 'is not',
      value: 'is not',
    },
    {
      label: 'is empty',
      value: 'is empty',
    },
    {
      label: 'is not empty',
      value: 'is not empty',
    },
  ],
};

export type DropdownOptionT = {
  label: string;
  value: string;
};

const SUBITEM_FILTER_CHAINING: DropdownOptionT[] = [
  {
    label: 'AND',
    value: 'AND',
  },
  {
    label: 'OR',
    value: 'OR',
  },
];

const EMPTY_UNEMPTY_CONDITIONS = ['is empty', 'is not empty'];

export {
  SUBITEM_FILTER_CONDITIONS,
  SUBITEM_FILTER_CHAINING,
  EMPTY_UNEMPTY_CONDITIONS,
};
